import React from 'react';
import { CheckIcon } from 'lucide-react';
type CheckListProps = {
  items: string[];
  tone?: 'light' | 'dark';
  columns?: 1 | 2;
};
export function CheckList({
  items,
  tone = 'light',
  columns = 1
}: CheckListProps) {
  const text = tone === 'dark' ? 'text-white/90' : 'text-ink';
  return <ul className={`grid gap-3 ${columns === 2 ? 'sm:grid-cols-2' : ''}`} data-id="element-17" data-mp="38nxqi1c069dh">
      {items.map(item => <li key={item} className={`flex items-start gap-3 text-[15px] font-medium leading-snug sm:text-base ${text}`} data-id="element-18" data-mp="33p330m33bwn1">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-19" data-mp="2ywtd361z6wkr">
            <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-20" data-mp="2tz1btlffxy3w" />
          </span>
          <span data-id="element-21" data-mp="2p19m8y29qo2v">{item}</span>
        </li>)}
    </ul>;
}